import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WolflandHome from "./components/WolflandHome";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WolflandHome />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;